import { Button, Link, List, ListItem, ListItemText, Popover, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import ArrowDownCircle from 'src/svgComponents/ArrowDownCircle'
import HomeIcon from 'src/svgComponents/HomeIcon'
import LogoWithText from 'src/svgComponents/LogoWithText'
import AppTooltip from "src/components/common/AppTooltip";
import useLogout from 'src/hooks/useLogout';
import { useSnackbar } from 'notistack'
import { PATH_AUTH, PATH_DASHBOARD } from "src/routes/paths";
import useStore from 'src/contexts/AuthProvider'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ShopIcon from '@mui/icons-material/Shop2Outlined'
// import RestaurantIcon from '@mui/icons-material/Restaurant'
import MenuIcon from '@mui/icons-material/Menu';
import { Close } from '@mui/icons-material'

const MainNavbar = ({ sidebarToogle, setSidebarToogle }) => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const { enqueueSnackbar } = useSnackbar();
	const logout = useLogout();
	const navigate = useNavigate();
	const userData = useStore(state => state);
	const [userType, setUserType] = useState("");
	let [userIconType, setUserIconType] = useState("");
	// console.log(userData.user?.category_type)


	useEffect(() => {
		if (userData) {
			let user_type = "";
			if (userData.user?.category_type === "1") {
				user_type = "Restaurant"
				userIconType = <ShopIcon />
			} else if (userData.user?.category_type === "2") {
				user_type = "Shop"
				userIconType = <ShopIcon />
			} else if (userData.user?.category_type === "3") {
				user_type = "Event"
			} else if (userData.user?.category_type === "4") {
				user_type = "Travel"
			} else if (userData.user?.category_type === "5") {
				user_type = "NGO"
			}
			setUserType(user_type)
			setUserIconType(userIconType)
		}
	}, [userData])

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleLogout = async (path) => {
		try {
			await logout();
			navigate(PATH_AUTH.login);
			handleClose();
		} catch (error) {
			enqueueSnackbar('unable to logout', { variant: 'error' });
		}
	};
	const getProfile = async (path) => {
		try {
			// await logout();
			navigate(PATH_DASHBOARD.general.getProfile);
			handleClose();
		} catch (error) {
			enqueueSnackbar('unable to get my profile', { variant: 'error' });
		}
	}
	const changePassword = async (path) => {
		try {
			// await logout();
			navigate(PATH_DASHBOARD.general.changePassword);
			handleClose();
		} catch (error) {
			enqueueSnackbar('unable to get my profile', { variant: 'error' });
		}
	}
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;
	return (
		<div className='navbar_wrapper'>
			<div className='navbar_container'>
				<div className='logo_container'>
					<NavLink to="/dashboard/" className='text-decoration-none'><LogoWithText /></NavLink>
				</div>
				<div className='navbar_config_container gap-2'>
					<div className="d-lg-none d-block">
						{
							!sidebarToogle ? (<Button onClick={() => setSidebarToogle(true)}>
								<MenuIcon sx={{ color: "#ffffff" }} />
							</Button>) : (
								<Button onClick={() => setSidebarToogle(false)}>
									<Close sx={{ color: "#ffffff" }} />
								</Button>
							)
						}
					</div>
					<div className="d-flex align-items-center">
						<div className='' style={{ color: "white", textDecoration: "none" }}>
							{userData?.user?.name}
						</div>
						<div>
							<Button onClick={(e) => handleClick(e)} className='main_nav_config_btn h-100' style={{ minWidth: "unset" }}><ArrowDownCircle /></Button>
							<Popover
								id={id}
								open={open}
								anchorEl={anchorEl}
								onClose={handleClose}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'right',
								}}
								transformOrigin={{
									vertical: 'top',
									horizontal: 'right',
								}}
							>
								<div className='logout_popover_content'>
									<List disablePadding>
										<ListItem>
											<Stack spacing={1} className="logout_popover_content_header">
												<div className='d-flex flex-column'>
													<span className='app_text_14_semibold'>{userType}</span>
													<span className='app_text_12_fw500 app_text_gray'>{userData?.role}</span>
												</div>
												{/* <span className='app_text_12_semibold app_text_black_3'>{userData?.user?.email}</span> */}
											</Stack>
										</ListItem>
										<ListItem>
											<Link onClick={() => getProfile(PATH_DASHBOARD.general.getProfile)} className="d-flex align-items-center w-100" style={{ textDecoration: "none" }}>
												<AccountCircleOutlinedIcon className="app_text_14 app_text_black d-flex align-items-center" style={{ height: "20", width: "20", textDecoration: "none" }} />
												<span className='app_text_14 d-flex align-items-center ms-3'>
													My Profile
												</span>
											</Link>
										</ListItem>
										<ListItem>
											<Link onClick={() => changePassword(PATH_DASHBOARD.general.changePassword)} className="d-flex align-items-center w-100" style={{ textDecoration: "none" }}>
												<LockOutlinedIcon className="app_text_14 app_text_black d-flex align-items-center" style={{ height: "20", width: "20" }} />
												<span className='app_text_14 d-flex align-items-center ms-3' >Change password</span>
											</Link>
										</ListItem>
										<ListItem>
											<Link className="d-flex align-items-center w-100" style={{ textDecoration: "none" }} onClick={() => handleLogout(PATH_AUTH.login)}>
												<LogoutOutlinedIcon className="app_text_14 app_text_black d-flex align-items-center" style={{ height: "20", width: "20" }} />
												<span className='app_text_14 d-flex align-items-center ms-3'>Logout</span>
											</Link>
										</ListItem>
									</List>
								</div>
							</Popover>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default MainNavbar